// extracted by mini-css-extract-plugin
export default {"imageWrapper":"OD-z","hovered":"PD-z","hoverImage":"QD-z","mainImage":"RD-z","imageNoBackground":"SD-z","fullSizeImage":"TD-z"};